export default __webpack_public_path__ + "static/media/dziecko_1.689dd7c6.svg";